/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */
import { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { usePrevious } from '@hooks/usePrevious';
import { useIntl } from 'react-intl';

import { CustomTrack } from '@components/overlays/CustomTrack';

import { getTrackValues } from './utils';

import { IAttributeFieldProps } from './types';
import * as S from './styles';

export const AttributeFieldTrack: React.FC<IAttributeFieldProps> = ({
  attribute,
}) => {
  const intl = useIntl();

  const [show, setShow] = useState(false);

  const { control, setValue } = useFormContext(); // retrieve all hook methods
  // TODO: handle double configuration
  // watching door width to get default value for track field
  const { width, configuration } = useWatch({
    //  name: ['width', 'configuration'],
  });

  const { defaultValue, maxValue, minValue } = getTrackValues(
    width,
    configuration
  );

  const previousWidth = usePrevious(width);
  const previousConfiguration = usePrevious(configuration);

  useEffect(() => {
    const widthChanged = previousWidth !== width;
    const configurationChanged = previousConfiguration !== configuration;
    if (widthChanged || configurationChanged) {
      // reset custom-track width to the new defaultValue
      setValue(attribute.attribute.slug, defaultValue);
    }
  }, [
    attribute.attribute.slug,
    defaultValue,
    previousWidth,
    setValue,
    width,
    configuration,
    previousConfiguration,
  ]);

  return (
    <Controller
      name={attribute.attribute.slug}
      control={control}
      render={({ field: { onChange, value } }) => (
        <S.Track>
          <CustomTrack
            hide={() => setShow(false)}
            show={show}
            attribute={attribute}
            defaultValue={defaultValue}
            minValue={minValue}
            maxValue={maxValue}
            value={value}
            onChange={onChange}
          />
          <S.PillButton
            active={value === defaultValue}
            type="button"
            onClick={() => onChange(defaultValue)}
          >
            <span>
              {intl.formatMessage({
                defaultMessage: 'Standard',
                id: 'cb2kY6',
              })}
            </span>
          </S.PillButton>
          <S.PillButton
            active={value !== defaultValue}
            type="button"
            onClick={() => setShow(true)}
          >
            <span>
              {intl.formatMessage({
                defaultMessage: 'Custom',
                id: 'Sjo1P4',
              })}
            </span>
          </S.PillButton>
        </S.Track>
      )}
    />
  );
};
